import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./style.scss";
import whitelogo from "../../assets/images/404-shape.svg";
import { BsCheckCircle } from "react-icons/bs";
import { Col, Modal, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { base_url } from "../../utils/constants";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import superagent from "superagent";
import PlanToBasicModel from "../../containers/membership/planToBasicModel";
import { pro_month, pro_year } from "../../containers/membership/constants";
import { IS_LOADING } from "../../store/constants";
import { higherPlan } from "../../utils/commonFunctions";
import { headerSlugs } from "../../utils/commonRouteUrl";

const ProModal = (props) => {
  const [show, setShow] = useState(false);
  const [disableProMonth, setDisableProMonth] = useState(false);
  const [disablePro, setDisablePro] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [coupon, setCoupon] = useState(props?.couponParam || "");
  const meta = useSelector((state) => state?.meta);
  const user_info = useSelector((state) => state?.my_account?.user_info);
  const dispatch = useDispatch();
  const cookie = new Cookies();
  const redirectUrl = useMemo(() => {
    return props?.redirectUrl ? decodeURIComponent(props?.redirectUrl) || "" : "";
  }, []);

  const redirectPlanUrl = useMemo(() => {
    return decodeURIComponent(props?.redirectUrl)?.replace("?redirect_url=", "") || "";
  }, []);

  const query = useMemo(() => {
    return coupon ? `?coupon=${coupon}` : "";
  }, [coupon]);

  const bothQueryAndRedirect = useMemo(() => {
    return query ? redirectUrl?.replace("?", "&") : redirectUrl;
  }, [query, redirectUrl]);

  useEffect(() => {
    if (props?.planParam && user_info?.subscription_type) {
      const prefill = higherPlan(user_info?.subscription_type?.toLowerCase(), props?.planParam?.split("-")?.join("_"));
      const prefilMonthCoupon = props.monthly && props?.planParam === pro_month && props?.couponParam;
      const prefilYearCoupon = !props.monthly && props?.planParam === pro_year && props?.couponParam;
      if (prefill && (prefilMonthCoupon || prefilYearCoupon)) {
        setCoupon(props.couponParam);
      } else {
        setCoupon("");
      }
    }
  }, [props.monthly, user_info]);

  const subscribeToPro = useCallback(() => {
    if (!user_info?.auth_token) {
      window.location.replace(`${headerSlugs?.login}?planType=PRO&redirectPlanUrl=${redirectPlanUrl}`);
    } else if (user_info?.subscription_type === "BASIC") {
      superagent
        .get(`${base_url}subscription/PRO${query}${bothQueryAndRedirect}`)
        .set("accept", "application/json")
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          setShow(false);
          dispatch({ type: IS_LOADING, payload: false });
          if (res.body.status) window.location = res.body.url;
          else toast.error(res.body.message);
        });
    } else {
      superagent
        .post(`${base_url}update-plan-data?plan=PRO${query.replace("?", "&")}${redirectUrl.replace("?", "&")}`)
        .set("accept", "application/json")
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          if (res?.body?.status === "create-new-plan") {
            superagent
              .get(`${base_url}subscription/PRO${query}${bothQueryAndRedirect}`)
              .set("accept", "application/json")
              .set("Authorization", cookie.get("user_token"))
              .end((_err, res) => {
                setShow(false);
                dispatch({ type: IS_LOADING, payload: false });
                window.location = res.body.url;
              });
          } else if (!res?.body?.status) {
            setShow(false);
            dispatch({ type: IS_LOADING, payload: false });
            toast.error(res.body.message);
          } else {
            setShow(false);
            dispatch({ type: IS_LOADING, payload: false });
            toast.success(res.body.message);
            props.onClosed();
            if (res.body.redirect_url) {
              window.location.replace(`${res.body.redirect_url}`);
            } else if (res?.body?.status === true) {
              window.location.replace("/my-account?scrollto=subscription");
            }
          }
        });
    }
  }, [user_info, query]);

  const subscribeToProMonth = useCallback(() => {
    if (!user_info?.auth_token) {
      window.location.replace(`${headerSlugs?.login}?planType=PRO_MONTH&redirectPlanUrl=${redirectPlanUrl}`);
    } else if (user_info?.subscription_type === "BASIC") {
      superagent
        .get(`${base_url}subscription/PRO_MONTH${query}${bothQueryAndRedirect}`)
        .set("accept", "application/json")
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          setShow(false);
          dispatch({ type: IS_LOADING, payload: false });
          if (res.body.status) window.location = res.body.url;
          else toast.error(res.body.message);
        });
    } else {
      superagent
        .post(`${base_url}update-plan-data?plan=PRO_MONTH${query.replace("?", "&")}${redirectUrl.replace("?", "&")}`)
        .set("accept", "application/json")
        .set("Authorization", cookie.get("user_token"))
        .end((_err, res) => {
          if (res?.body?.status === "create-new-plan") {
            superagent
              .get(`${base_url}subscription/PRO_MONTH${query}${bothQueryAndRedirect}`)
              .set("accept", "application/json")
              .set("Authorization", cookie.get("user_token"))
              .end((_err, res) => {
                setShow(false);
                dispatch({ type: IS_LOADING, payload: false });
                window.location = res.body.url;
              });
          } else if (!res?.body?.status) {
            setShow(false);
            dispatch({ type: IS_LOADING, payload: false });
            toast.error(res.body.message);
          } else {
            setShow(false);
            dispatch({ type: IS_LOADING, payload: false });
            toast.success(res.body.message);
            props.onClosed();
            if (res.body.redirect_url) {
              window.location.replace(`${res.body.redirect_url}`);
            } else if (res?.body?.status === true) {
              window.location.replace("/my-account?scrollto=subscription");
            }
          }
        });
    }
  }, [user_info, query]);

  const handleClick = () => {
    if (props.monthly) {
      setShowPopup(false);
      subscribeToProMonth();
    } else {
      setShowPopup(false);
      subscribeToPro();
    }
  };

  return (
    <>
      <Modal size="xl" centered show={props.isOpen} onHide={props.onClosed}>
        <span onClick={props.onClosed} className="position-absolute end-0 top-0 pe-2 pt-1 cursor-pointer">
          <i className="fa-regular fa-2x fa-xmark"></i>
        </span>

        <div className="p-3 p-md-4 p-lg-5">
          <Row className="founder__modal">
            <Col lg={6} className="confirm__left">
              {/* <img src={logo} className="toplogo" alt="" /> */}
              <h5 className="fw-bold">{props.title}</h5>
              {props.content && <p>{props.content}</p>}
              <ul className="planTabs d-flex text-center fw-bold my-4 p-0">
                {disablePro ? (
                  <li className={`btn ${!props.monthly ? "freeTrial active fw-bold" : ""}`}>ANNUAL</li>
                ) : (
                  <li
                    className={`btn ${!props.monthly ? "freeTrial active fw-bold" : ""}`}
                    onClick={() => {
                      if (user_info?.subscription_type === "PRO" && user_info?.type !== "trial") {
                        toast.success(`You are already ${user_info?.subscription_type} member.`, { autoClose: 2000 });
                        setDisablePro(true);
                        setTimeout(() => {
                          setDisablePro(false);
                        }, 3000);
                      } else {
                        props.setMonthly(false);
                      }
                    }}
                  >
                    ANNUAL
                  </li>
                )}
                {disableProMonth ? (
                  <li className={`btn ${props.monthly ? "freeTrial active fw-bold" : ""}`}>Monthly</li>
                ) : (
                  <li
                    className={`btn ${props.monthly ? "freeTrial active fw-bold" : ""}`}
                    onClick={() => {
                      if (user_info?.subscription_type === "PRO_MONTH" && user_info?.type !== "trial") {
                        toast.success(`You are already ${user_info?.subscription_type} member.`, { autoClose: 4000 });
                        setDisableProMonth(true);
                        setTimeout(() => {
                          setDisableProMonth(false);
                        }, 3000);
                      } else {
                        props.setMonthly(true);
                      }
                    }}
                  >
                    <a>Monthly</a>
                  </li>
                )}
              </ul>
              <h4 className="fw-bold border-bottom pb-4 mb-4">
                <span className="text-darkblue">{props.monthly ? "$19.99" : "$199.00"}</span>
                <span className="text-gray-400" style={{ color: "#bdbcbc" }}>
                  /{props.monthly ? "Month" : "Year"}
                </span>
              </h4>

              <ul>
                <li className="mb-3">
                  <BsCheckCircle className="me-2" color="#114bce" size={18} />
                  Access to Basic, Premium, + Pro resources
                </li>
                <li className="mb-3">
                  <BsCheckCircle className="me-2" color="#114bce" size={18} />
                  Enroll in reduced rate health insurance plans
                </li>
                <li className="mb-3">
                  <BsCheckCircle className="me-2" color="#114bce" size={18} />
                  Participate in our Community Forum
                </li>
                <li className="mb-3">
                  <BsCheckCircle className="me-2" color="#114bce" size={18} />
                  Access to a full suite of private practice tools and calculators
                </li>
                <li className="mb-3">
                  <BsCheckCircle className="me-2" color="#114bce" size={18} />
                  Make note taking a breeze with Clarity Notes - your customizable point-and-click therapy notes generator
                </li>
              </ul>
              {!props?.isFreeTrial && (
                <>
                  <label htmlFor="coupon_code">Coupon Code</label>
                  <input
                    className="form-control"
                    type="text"
                    value={coupon}
                    onChange={(e) => setCoupon(e.target.value)}
                    placeholder="Coupon Code"
                    id="coupon_code"
                  />
                </>
              )}

              <Row className="g-3 mt-3">
                <Col xs="auto">
                  <button onClick={props.onClosed} type="button" className="btn btn-danger fw-bold">
                    Maybe Later<i className="fa-solid fa-xmark ms-2"></i>
                  </button>
                </Col>
                {!show ? (
                  <Col xs="auto">
                    <button
                      type="submit"
                      onClick={() => {
                        if (props.monthly) {
                          if (user_info?.type === "trial") {
                            setShowPopup(true);
                          } else {
                            subscribeToProMonth();
                          }
                        } else if (user_info?.type === "trial") {
                          setShowPopup(true);
                        } else {
                          subscribeToPro();
                        }
                        setShow(true);
                      }}
                      className="btn btn-success fw-bold"
                      disabled={meta?.isLoading}
                    >
                      Upgrade to pro
                      <i className="fa-solid fa-arrow-right ms-2"></i>
                    </button>
                  </Col>
                ) : (
                  <Col xs="auto">
                    <button type="submit" className="btn btn-success fw-bold" disabled={meta?.isLoading}>
                      Loading...
                      <Spinner animation="border" size="sm" />
                    </button>
                  </Col>
                )}
              </Row>
            </Col>
            <Col
              lg={5}
              xl={4}
              className={`d-none text-center text-white position-static d-lg-flex align-items-center justify-content-center position-absolute end-0 confirm__right`}
            >
              <div>
                <img src={whitelogo} alt="" width={75} />
                <h3 className="fw-bold mb-0">Pro</h3>
                <p className="mb-0">{props.monthly ? "Monthly" : "Yearly"} Membership</p>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>
      {showPopup && (
        <PlanToBasicModel
          isOpen={showPopup}
          onClosed={() => setShowPopup(false)}
          message="Are you sure you want to upgrade? Free Trial will be cancelled."
          setShow={setShow}
          onClick={handleClick}
          isFree
        />
      )}
    </>
  );
};
export default ProModal;
